<template>
	<div
		:class="[className, !isValid ? 'invalid-mapping' : '']"
		@mouseover="onHoverHandler"
		@mouseleave="onLeaveHandler"
		@click="fieldClickHandler"
		:style="{
			left: data.left + 'px',
			top: data.top + 'px',
			width: data.width + 'px',
			height: data.height + 'px',
		}"
	>
		<span
			class="field-name"
			ref="fieldName"
			>{{ data.name }}</span
		>
		<span
			class="field-expression"
			ref="fieldExpression"
			>{{ data.fullyQualifiedProperty }}</span
		>
	</div>
</template>

<script>
	import util from '@core/services/util';

	export default {
		name: 'PDFPageFieldsOverlay',
		props: ['data', 'onClickField'],
		data() {
			return {
				parentComponent: null,
				className: 'pdf-preview-page-field',
			};
		},
		computed: {
			util() {
				return util;
			},
			isValid() {
				return this.data.fullyQualifiedProperty;
			},
		},
		async created() {
			this.parentComponent = this.$parent;
		},
		async mounted() {
			if (this.$refs.fieldName.clientWidth + this.data.left > this.data.pageSize) {
				this.$refs.fieldName.style.right = '0px';
				this.$refs.fieldName.style.left = 'auto';
			}

			if (this.$refs.fieldExpression.clientWidth + this.data.left > this.data.pageSize) {
				this.$refs.fieldExpression.style.right = '0px';
				this.$refs.fieldExpression.style.left = 'inher';
			}
		},
		methods: {
			fieldClickHandler() {
				if (this.onClickField && typeof this.onClickField == 'function') {
					this.onClickField(this.data);
				}
			},
			onHoverHandler() {
				this.$el.style.zIndex = 9999999;
				let allFields = this.parentComponent.$el.getElementsByClassName(this.className);

				let selfBounding = this.$el.getBoundingClientRect();

				for (let field of allFields) {
					let fieldBounding = field.getElementsByClassName('field-name')[0].getBoundingClientRect();
					if (
						!(
							fieldBounding.top > selfBounding.bottom ||
							fieldBounding.bottom < selfBounding.top ||
							fieldBounding.left > selfBounding.right ||
							fieldBounding.right < selfBounding.left
						)
					) {
						field.classList.add('hide-field-name');
					}
				}
				this.$el.classList.remove('hide-field-name');
			},
			onLeaveHandler() {
				let allFields = this.parentComponent.$el.getElementsByClassName(this.className);

				for (let field of allFields) {
					field.style.zIndex = 1;
					field.classList.remove('hide-field-name');
				}
			},
		},
	};
</script>

<style>
	.pdf-preview-page-field {
		box-sizing: border-box;
		position: absolute;
		display: flex;
		align-items: center;
		background-color: var(--main-color);
		opacity: 0.2;
		z-index: 1;
	}

	.pdf-preview-page-field.selected {
		box-shadow:
			1px 1px inset var(--pill-warning-color),
			-1px -1px inset var(--pill-warning-color);
		opacity: 1;
		background-color: #f9ff0222;
	}

	.pdf-preview-page-field.selected.hide-field-name .field-name {
		opacity: 0;
	}

	.pdf-preview-page-field.invalid-mapping {
		box-shadow:
			1px 1px inset var(--pill-danger-color),
			-1px -1px inset var(--pill-danger-color);
		opacity: 1;
		background-color: #c01b1b23;
	}

	.pdf-preview-page-field.selected .field-name {
		color: black;
		background-color: var(--pill-warning-color);
		opacity: 1;
		pointer-events: all;
	}

	.pdf-preview-page-field:hover {
		z-index: 10000;
		cursor: pointer;
		box-shadow:
			1px 1px inset var(--main-color),
			-1px -1px inset var(--main-color);
		opacity: 1;
		background-color: #46709922;
	}

	.pdf-preview-page-field.invalid-mapping:hover {
		box-shadow:
			1px 1px inset var(--pill-danger-color),
			-1px -1px inset var(--pill-danger-color);
		background-color: #772b2b23;
	}

	.pdf-preview-page-field .field-name {
		top: 0;
		transform: translateY(-100%);
	}

	.pdf-preview-page-field .field-expression {
		bottom: 0;
		transform: translateY(100%);
	}

	.pdf-preview-page-field .field-name,
	.pdf-preview-page-field .field-expression {
		color: transparent;
		left: 0;
		position: absolute;
		opacity: 0;
		pointer-events: none;
		background-color: transparent;
		padding: 0 3px;
		font-size: 12px;
	}

	.pdf-preview-page-field:hover .field-name,
	.pdf-preview-page-field:hover .field-expression {
		background-color: var(--main-color);
		color: white;
		opacity: 1;
	}

	.pdf-preview-page-field.invalid-mapping:hover .field-name,
	.pdf-preview-page-field.invalid-mapping:hover .field-expression {
		background-color: var(--pill-danger-color);
		color: white;
	}
</style>
